/* Tab-scoped catalogue continuity. Storage failures never block browsing. */
(() => {
  'use strict';
  const META = 'fd:catalogue:visit:v7', DATA = 'fd:catalogue:snapshot:v7', TTL = 30 * 60 * 1000;
  const newKey = () => Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  const canonical = input => {
    const u = new URL(input, location.origin);
    u.hash = ''; u.searchParams.delete('fdreturn'); u.searchParams.delete('page'); u.searchParams.delete('fdpopular');
    if (!u.searchParams.get('fdf')) u.searchParams.delete('fdf');
    u.searchParams.sort(); return u.href;
  };
  const readMeta = () => {
    try {
      const meta = JSON.parse(sessionStorage.getItem(META));
      if (!meta || Date.now() - meta.time > TTL || !Number.isFinite(meta.scroll) || !Number.isFinite(meta.shown)) return null;
      const url = new URL(meta.url);
      if (url.origin !== location.origin || !/^\/collections\/[^/]+$/.test(url.pathname)) return null;
      return meta;
    } catch (_) { return null; }
  };
  window.FDCatalogueJourney = {
    newKey,
    identify() {
      const url = new URL(location.href), key = url.searchParams.get('fdreturn') || history.state?.fdJourney || newKey();
      url.searchParams.delete('fdreturn');
      history.replaceState(Object.assign({}, history.state, {fdJourney:key}), '', url);
    },
    save(details, snapshot) {
      const key = history.state?.fdJourney;
      if (!key) return;
      try {
        // Keep one full cursor snapshot per tab so a long catalogue cannot crowd out unrelated storage.
        sessionStorage.removeItem(DATA);
        const meta = Object.assign({}, details, {key, url:canonical(location.href), time:Date.now()});
        sessionStorage.setItem(META, JSON.stringify(meta));
        if (snapshot) sessionStorage.setItem(DATA, JSON.stringify({key, time:meta.time, snapshot}));
      } catch (_) { /* The small metadata survives a full snapshot quota error; the loader can replay it. */ }
    },
    restore() {
      const meta = readMeta();
      if (!meta || meta.key !== history.state?.fdJourney || meta.url !== canonical(location.href)) return null;
      let data = null;
      try {
        const stored = JSON.parse(sessionStorage.getItem(DATA));
        if (stored?.key === meta.key && stored.time === meta.time && Array.isArray(stored.snapshot?.cards) && Array.isArray(stored.snapshot?.states)) data = stored.snapshot;
      } catch (_) {}
      return {meta, data};
    },
    returnLink(link) {
      const meta = readMeta();
      if (!meta || !link) return;
      const url = new URL(meta.url); url.searchParams.set('fdreturn', meta.key);
      link.href = url.href; link.hidden = false;
    }
  };
})();
